import React from "react";
import EventsImageGallery from "../components/events/EventsImageGallery";

export default function GalleryPage() {
  return <EventsImageGallery />;
}